import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './DeleteAccountButton.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const DeleteAccountButton = () => {
  const { getAccessTokenSilently, logout } = useAuth0();

  const handleDeleteAccount = async () => {
    if (!window.confirm('Delete account permanently? This cannot be undone.')) return;

    try {
      const token = await getAccessTokenSilently();
      await fetch(`${API_BASE_URL}/api/users/me`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      logout({ returnTo: window.location.origin });
    } catch (error) {
      console.error('Delete account failed:', error);
      alert('Failed to delete account. Please try again.');
    }
  };

  return (
    <button
      onClick={handleDeleteAccount}
      className="btn btn-danger"
    >
      Delete Account
    </button>
  );
};

export default DeleteAccountButton;